export default "__VITE_ASSET__GW94vYst__"